<div class="progress">
  @if (showPercentProgress) {
    <div class="progress__status">{{ getProgressInPercent() }} %</div>
  }
  <div class="progress__bar-container">
    <div class="progress__bar" [style]="'width:'+getProgressInPercent()+'%'"></div>
  </div>
  @if (message) {
    <div class="progress__additional-text">{{ message }}</div>
  }
</div>
